// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimeDurationInput_timeDurationInput__iRWDZ .TimeDurationInput_seconds__n9cXY {
    width: 24px;
    text-align: center;
    height: 24px;
    border-radius: 0px;
    user-select: none;
    padding: 1px 2px;
}

.TimeDurationInput_timeDurationInput__iRWDZ .TimeDurationInput_minutes__20akP {
    width: 24px;
    text-align: center;
    height: 24px;
    border-radius: 0px;
    user-select: none;
    padding: 1px 2px;
}

.TimeDurationInput_timeDurationInput__iRWDZ .TimeDurationInput_hours__CWUEd {
    width: 24px;
    text-align: center;
    height: 24px;
    border-radius: 0px;
    user-select: none;
    padding: 1px 2px;
}

.TimeDurationInput_timeDurationInput__iRWDZ .TimeDurationInput_inputWide__i4l2h {
    width: 32px;
}

.TimeDurationInput_timeDurationInput__iRWDZ {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: white;
    border: 1.5px solid var(--color-lightui-surface-4);
    width: fit-content;
    border-radius: 4px;
    padding: 0 4px;
    height: 2rem;
    font-size: 14px;
    gap: 4px;
}

.TimeDurationInput_timeDurationInput__iRWDZ:not(.TimeDurationInput_disabled__imqmR):hover {
    border: 1.5px solid var(--color-lightui-accent-2);
}

.TimeDurationInput_timeDurationInput__iRWDZ:focus-within {
    outline: 2.5px solid var(--color-primary);
    outline-offset: -1.5px;
}

.TimeDurationInput_timeDurationInput__iRWDZ input {
    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    border: none;
    box-shadow: none;
    width: 24px;
    font-size: 14px;
    height: 24px;
    border-radius: 0px;
    text-align: center;
    overflow: hidden;
    background-color: transparent !important;
    background: transparent !important;
}

.TimeDurationInput_disabled__imqmR {
    cursor: not-allowed;
    background-color: var(--color-lightui-surface-2);
}

.TimeDurationInput_timeDurationInput__iRWDZ input:focus {
    background-color: var(--color-highlight) !important;
}

.TimeDurationInput_timeDurationInput__iRWDZ input::selection {
    background-color: transparent;
}

.TimeDurationInput_timeDurationInput__iRWDZ .TimeDurationInput_appendedLabel__VFzxO {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    margin-left: -1.5px;
    color: var(--color-secondary);
    box-shadow: none;
    border-left: 1.5px solid var(--color-lightui-surface-4);
    border-radius: 0px 4px 4px 0px;
    padding-left: 8px;
    padding-right: 8px;
    height: 100%;
}

.TimeDurationInput_hours__CWUEd:focus {
    background-color: var(--color-highlight) !important;
}

.TimeDurationInput_minutesNoHours__mI9yh:focus {
    background-color: var(--color-highlight) !important;
}

.TimeDurationInput_timeDurationInput__iRWDZ input:focus {
    background-color: var(--color-highlight);
    caret-color: transparent;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/TimeDurationInput/TimeDurationInput.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,kDAAkD;IAClD,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA;IACI,uHAAuH;IACvH,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uHAAuH;IACvH,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,uDAAuD;IACvD,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,wCAAwC;IACxC,wBAAwB;AAC5B;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B","sourcesContent":[".timeDurationInput .seconds {\n    width: 24px;\n    text-align: center;\n    height: 24px;\n    border-radius: 0px;\n    user-select: none;\n    padding: 1px 2px;\n}\n\n.timeDurationInput .minutes {\n    width: 24px;\n    text-align: center;\n    height: 24px;\n    border-radius: 0px;\n    user-select: none;\n    padding: 1px 2px;\n}\n\n.timeDurationInput .hours {\n    width: 24px;\n    text-align: center;\n    height: 24px;\n    border-radius: 0px;\n    user-select: none;\n    padding: 1px 2px;\n}\n\n.timeDurationInput .inputWide {\n    width: 32px;\n}\n\n.timeDurationInput {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    background-color: white;\n    border: 1.5px solid var(--color-lightui-surface-4);\n    width: fit-content;\n    border-radius: 4px;\n    padding: 0 4px;\n    height: 2rem;\n    font-size: 14px;\n    gap: 4px;\n}\n\n.timeDurationInput:not(.disabled):hover {\n    border: 1.5px solid var(--color-lightui-accent-2);\n}\n\n.timeDurationInput:focus-within {\n    outline: 2.5px solid var(--color-primary);\n    outline-offset: -1.5px;\n}\n\n.timeDurationInput input {\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    border: none;\n    box-shadow: none;\n    width: 24px;\n    font-size: 14px;\n    height: 24px;\n    border-radius: 0px;\n    text-align: center;\n    overflow: hidden;\n    background-color: transparent !important;\n    background: transparent !important;\n}\n\n.disabled {\n    cursor: not-allowed;\n    background-color: var(--color-lightui-surface-2);\n}\n\n.timeDurationInput input:focus {\n    background-color: var(--color-highlight) !important;\n}\n\n.timeDurationInput input::selection {\n    background-color: transparent;\n}\n\n.timeDurationInput .appendedLabel {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 21px;\n    margin-left: -1.5px;\n    color: var(--color-secondary);\n    box-shadow: none;\n    border-left: 1.5px solid var(--color-lightui-surface-4);\n    border-radius: 0px 4px 4px 0px;\n    padding-left: 8px;\n    padding-right: 8px;\n    height: 100%;\n}\n\n.hours:focus {\n    background-color: var(--color-highlight) !important;\n}\n\n.minutesNoHours:focus {\n    background-color: var(--color-highlight) !important;\n}\n\n.timeDurationInput input:focus {\n    background-color: var(--color-highlight);\n    caret-color: transparent;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timeDurationInput": `TimeDurationInput_timeDurationInput__iRWDZ`,
	"seconds": `TimeDurationInput_seconds__n9cXY`,
	"minutes": `TimeDurationInput_minutes__20akP`,
	"hours": `TimeDurationInput_hours__CWUEd`,
	"inputWide": `TimeDurationInput_inputWide__i4l2h`,
	"disabled": `TimeDurationInput_disabled__imqmR`,
	"appendedLabel": `TimeDurationInput_appendedLabel__VFzxO`,
	"minutesNoHours": `TimeDurationInput_minutesNoHours__mI9yh`
};
export default ___CSS_LOADER_EXPORT___;
